<section class="loren-automation-plan-section">
  <div class="loren-automation-plan-section-number">{{ number }}</div>
  <div class="loren-automation-plan-section-main">
    @if(title) {
    <h4 class="loren-automation-plan-section-title">{{ title }}</h4>
    } @if(subtitle) {
    <p class="loren-automation-plan-section-subtitle">{{ subtitle }}</p>
    }
    <ng-content></ng-content>
  </div>
</section>
